import { Api } from '@/api/api';
import { Enquiry } from '@/models/enquiry';
import { EnquiryFilters } from '@/models/enquiry-filters';
import { PagedEnquiryResult } from '@/models/paged-enquiry-result';
import { EnquiryHistory } from '@/models/enquiry-history';
import { EnquiryDocument } from '@/models/enquiry-document';
import { EnquiryComment } from '@/models/enquiry-comment';

export class EnquiryApi extends Api {
    public async fetchForUserAsync(userId: number, filters: EnquiryFilters): Promise<PagedEnquiryResult> {
        return await this.getAsync<PagedEnquiryResult>(`v2/user/${userId}/enquiries`, filters);
    }
    public async fetchAsync(filters: EnquiryFilters): Promise<PagedEnquiryResult> {
        return await this.getAsync<PagedEnquiryResult>('v2/enquiry', filters);
    }
    public async fetchByIdAsync(id: string): Promise<Enquiry> {
        return await this.getAsync<Enquiry>('v2/enquiry/' + id);
    }
    public async fetchHistoryByIdAsync(id: string): Promise<Array<EnquiryHistory>> {
        return await this.getAsync<Array<EnquiryHistory>>(`v2/enquiry/${id}/history`);
    }
    public async fetchDocumentsAsync(id: string): Promise<Array<EnquiryDocument>> {
        return await this.getAsync<Array<EnquiryDocument>>(`v2/enquiry/${id}/documents`);
    }
    public async fetchCommentsAsync(id: string): Promise<Array<EnquiryComment>> {
        return await this.getAsync<Array<EnquiryComment>>(`v2/enquiry/${id}/comments`);
    }
    public async createAsync(enquiry: Enquiry): Promise<string> {
        const location = await this.postAsync<string>('v2/enquiry', enquiry);
        const id = location.replace(this.buildUrl('v2/enquiry/'), '');
        return id;
    }
    public async createDocumentAsync(id: string, file: File): Promise<void> {
        await this.postFileAsync<string>(`v2/enquiry/${id}/documents`, file);
    }
    public async deleteDocumentAsync(id: string, enquiryId: string): Promise<void> {
        await this.deleteAsync<void>(`v2/enquiry/${enquiryId}/documents/${id}`);
    }
    public async downloadDocumentAsync(id: string, enquiryId: string): Promise<void> {
        window.open(this.buildUrl(`v2/enquiry/${enquiryId}/documents/${id}`), '_blank');
    }
    public async createCommentAsync(id: string, comment: EnquiryComment): Promise<void> {
        await this.postAsync<string>(`v2/enquiry/${id}/comments`, comment);
    }
    public async deleteCommentAsync(id: string, enquiryId: string): Promise<void> {
        await this.deleteAsync<string>(`v2/enquiry/${enquiryId}/comments/${id}`);
    }
}
